export default class Configuration {
    static get CONFIG(): any {
        return {
            VUE_APP_SG_API_HOST: '$VUE_APP_SG_API_HOST',
            VUE_APP_HQ_API_HOST: '$VUE_APP_HQ_API_HOST',
            VUE_APP_HQ_API_KEY: '$VUE_APP_HQ_API_KEY',
            VUE_APP_GOOGLE_MAPS_KEY: '$VUE_APP_GOOGLE_MAPS_KEY',
        };
    }

    static value(name: any) {
        if (!(name in this.CONFIG)) {
            console.error(`Configuration: There is no key named "${name}"`);
            return;
        }

        const value = this.CONFIG[name];

        if (!value) {
            console.error(`Configuration: Value for "${name}" is not defined`);
            return;
        }

        if (value.startsWith('$VUE_APP_')) {
            // value was not replaced, it seems we are in development.
            // Remove $ and get current value from process.env
            const envName = value.substr(1);
            const envValue = process.env[envName];
            if (envValue) {
                return envValue;
            }
            console.error(`Configuration: Environment variable "${envName}" is not defined`);
        } else {
            // value was already replaced, it seems we are in production.
            return value;
        }
    }
}
